import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./TrackOrder.css";
import Top_Heading from "./top_heading/Top_Heading";
import UserInfo from "./UserInfo/UserInfo";
import Order_details_table from "../my_orders/order_details/order_details_table/Order_details_table";
import Estimate_Time_Component from "../common_components/Estimate_Time_Component/Estimate_Time_Component";
import Delivery_Partner from "./delivery_partner/Delivery_Partner";
import Payment_Summary from "../cart/payment_summary/Payment_Summary";
import Green_Btn from "../common_components/common_btn/green_btn/Green_Btn";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../features/order/orderSlice";

const TrackOrder = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const trackorder = useSelector((state) => state.order.order);
  useEffect(() => {
    const res = dispatch(getOrder(id));
    if (res.meta?.requestStatus === "fulfilled") {
    } else if (res.meta?.requestStatus === "rejected") {
    }
  }, [dispatch]);

  const data = {
    total_mrp: trackorder?.total_mrp,
    total_tax: trackorder?.total_tax,
    total_cess: trackorder?.total_cess,
    no_of_item: trackorder?.no_of_item,
    total_selling_price: trackorder?.total_selling_price,
    total_amount: trackorder?.total_amount,
  };

  const navigate = useNavigate();

  return (
    <section className="TrackOrder">
      <Top_Heading data={data} order={trackorder} />

      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <UserInfo
              user={trackorder?.User}
              address={trackorder?.User_Address}
              payment={trackorder?.Payment_Method}
            />
            <div className="table_div">
              <Order_details_table dontShowPrice={true} order={trackorder} />
            </div>
          </div>
          <div className="col-lg-4">
            <Estimate_Time_Component order={trackorder} />
            <Delivery_Partner delivery_boy={trackorder?.delivery_boy} />
            <Payment_Summary data={data} />
          </div>
        </div>

        <div className="btn_holder">
          <Green_Btn
            btn_name="Go to Home"
            onClick={() => {
              navigate("/");
            }}
          />
        </div>
      </div>

      {/* <OrderInfo callText={"Call Store"} />
                <UserInfo />
                <Orderetails /> */}
    </section>
  );
};

export default TrackOrder;
